import type { RouteObject } from 'react-router';

import { PERMISSIONS } from '@/constants/permissions';
import { ROUTES } from '@/constants/routes';
import { RequirePermission } from '@/features/auth';

export const memberRoutes: RouteObject[] = [
  {
    element: <RequirePermission permission={PERMISSIONS.MEMBERS_READ} />,
    children: [
      {
        path: ROUTES.MEMBERS,
        lazy: async () => ({ Component: (await import('./pages/MembersPage')).MembersPage }),
      },
      {
        path: ROUTES.MEMBER_DETAIL,
        lazy: async () => ({
          Component: (await import('./pages/MemberDetailPage')).MemberDetailPage,
        }),
      },
    ],
  },
];
